import React, {Component} from 'react';
import { Icon } from '@/components/Common/Lib';
import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';

import {useRouteError} from 'react-router-dom';

// Surfaces the React Router route error inline during the MUI migration so a human
// can see the actual failure instead of just the modal. Remove or hide once the
// migration is done.
const RouteErrorDetails = () => {
  let error;
  try { error = useRouteError(); } catch { error = null; }
  if (!error) return null;
  let message;
  if (typeof error === 'string') message = error;
  else if (error instanceof Error) message = error.message;
  else if (error && typeof error === 'object') {
    message = error.message ?? error.statusText ?? error.error?.message ?? JSON.stringify(error, null, 2);
  } else message = String(error);
  const stack = error?.stack ?? error?.error?.stack ?? '';
  return (
    <pre style={{ textAlign: 'left', whiteSpace: 'pre-wrap', maxHeight: 300, overflow: 'auto', fontSize: 11, padding: 8, background: '#fff3f3', border: '1px solid #f99', color: '#5f2120' }}>
      {message}{stack ? '\n\n' + stack : ''}
    </pre>
  );
};

class ErrorBoundary extends Component {

  constructor(props) {
    super(props);
    this.state = { eventId: null };
  }

  render() {
    const navigateToHome = () => {
      window.location.href = '/'
    };

    return (
      <Dialog
        size="tiny"
        open
        onClose={() => {
          navigateToHome()
        }}
      >
        <DialogContent>
          <div style={{ textAlign: 'center' }}>
            <Typography component="h1" variant="h1">Hrmm... something broke.</Typography>
            <Icon name="frown outline" size="massive" disabled />
            <p>Please let us know what happened.</p>
            <RouteErrorDetails />
            <Button 
              onClick={e => {
                e.preventDefault();
                navigateToHome()
              }}
            color="primary" variant="contained">
              Send Feedback
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default ErrorBoundary;
